var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-69.269 -212.73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.326,266.7H78.978a4.714,4.714,0,0,1-4.709-4.708V228.007a4.714,4.714,0,0,1,4.709-4.709h41.348a4.714,4.714,0,0,1,4.709,4.709v33.988A4.714,4.714,0,0,1,120.326,266.7ZM78.978,225.3a2.712,2.712,0,0,0-2.709,2.709v33.988a2.711,2.711,0,0,0,2.709,2.708h41.348a2.711,2.711,0,0,0,2.709-2.708V228.007a2.712,2.712,0,0,0-2.709-2.709Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.782,
    height: 4.782,
    transform: "translate(84.547 242.653)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.782,
    height: 4.782,
    transform: "translate(96.503 242.653)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.782,
    height: 4.782,
    transform: "translate(108.458 242.653)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.782,
    height: 4.782,
    transform: "translate(84.547 252.218)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.782,
    height: 4.782,
    transform: "translate(96.503 252.218)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.782,
    height: 4.782,
    transform: "translate(108.458 252.218)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.822,
    height: 2,
    transform: "translate(75.548 233.285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.085,227.834a1,1,0,0,1-1-1v-7.1a1,1,0,1,1,2,0v7.1A1,1,0,0,1,87.085,227.834Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.241,227.834a1,1,0,0,1-1-1v-7.1a1,1,0,0,1,2,0v7.1A1,1,0,0,1,113.241,227.834Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6ef762e4a75199c954a025cf432b1b0c.svg";
export { ForwardRef as ReactComponent };